import React from 'react';
import { styled } from '@linaria/react';
import { SideShadow } from 'components/Accommodation/AccommodationView/Mobile/styles';
import { HorizontalScroll } from '@daedalus/atlas/helpers/HorizontalScroll';
import { Icon } from '@daedalus/atlas/Icon';
import { Pill } from '@daedalus/atlas/Pill/Pill';
import { Text } from '@daedalus/atlas/Text';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { FilterKey, messages } from './constants';
import { getSortedFiltersConfig } from './helpers';
const PositionerWrapper = /*#__PURE__*/styled('div')({
  name: "PositionerWrapper",
  class: "pnsn2b4",
  propsAsIs: false
});
const HorizontalScrollWrapper = /*#__PURE__*/styled('div')({
  name: "HorizontalScrollWrapper",
  class: "h114rh07",
  propsAsIs: false
});
const _exp5 = /*#__PURE__*/() => Text;
const FilterBy = /*#__PURE__*/styled(_exp5())({
  name: "FilterBy",
  class: "f1g3omo6",
  propsAsIs: true
});
interface PropsTypes {
  activeFilters: Array<FilterKey>;
  onFilterClick: (id: string) => void;
  isLabelVisible?: boolean;
  shouldShowFreeCancellation?: boolean;
}
export const OffersFilter = ({
  activeFilters,
  onFilterClick,
  isLabelVisible = true,
  shouldShowFreeCancellation = true
}: PropsTypes) => {
  const sortedFilters = getSortedFiltersConfig(activeFilters);
  return <PositionerWrapper>
      <HorizontalScrollWrapper>
        <HorizontalScroll columnGap="s300" rowGap="s300">
          {isLabelVisible && <FilterBy variant="labelS" colorPath="content.neutral.c700">
              <FormattedMessageWrapper defaultMessage="Filters" id="filters" />
            </FilterBy>}
          {sortedFilters.map(filter => {
          if (filter.id === 'freeCancellation' && !shouldShowFreeCancellation) {
            return null;
          }
          return <Pill key={filter.id} isSelected={activeFilters.includes(filter.id)} onClick={() => onFilterClick(filter.id)} iconStart={<Icon name={filter.icon} />}>
                <FormattedMessageWrapper {...messages[filter.id]} />
              </Pill>;
        })}
        </HorizontalScroll>
      </HorizontalScrollWrapper>
      <SideShadow side="end" />
    </PositionerWrapper>;
};

require("./OffersFilter.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./OffersFilter.tsx");